/**
 * Turn an API failure into something a customer can act on.
 *
 * The backend speaks its own language: an expired or rejected credential comes
 * back as AdonisJS's default "Unauthorized access", which told buyers nothing
 * and read like the site was broken. Anything auth-shaped becomes a plain
 * instruction to sign in again; everything else keeps the server's message,
 * which is usually specific and useful ("Only 2 seats left in Gold").
 */
const AUTH_STATUSES = [401, 403];

export const isAuthError = (error) => AUTH_STATUSES.includes(error?.response?.status);

export const friendlyError = (error, fallback = 'Something went wrong. Please try again.') => {
  if (isAuthError(error)) {
    return 'Your session has expired. Please log in again to continue.';
  }
  return error?.response?.data?.message || error?.message || fallback;
};
